import { UtilsService } from "../../services";
import { IDocumentModel } from "../documents/document.model";
import { IDropdownModel } from "../dropdown/dropdown.model";
import { IAutoCoverSpecModel } from "./auto-cover-spec.model";

export class EquipmentTrackingModel implements IEquipmentTrackingModel{
    constructor() {
        this.documentKey = UtilsService.newGuid();
    }
    equipmentTrackingId: number;
    companyId: number;
    jobId: number;
    // The pool/spa this equipment is installed on. Null on rows that predate the Assets tab.
    structureId?: number;
    equipmentName: string;
    manufacturer: string;
    otherManufacturer: string;
    model: string;
    oemsku: string;
    serialNumber: string;
    installedDate?: Date;
    documentKey: string;
    isDefault: boolean;
    showDropdown: boolean;
    lockedSerailNumber: boolean;
    lockedInstalledDate: boolean;
    btu: number;
    filterType: string;
    heaterType: string;

    notes: string;

    // Only populated for the Auto Cover record (see AUTO_COVER_EQUIPMENT_NAME)
    autoCover: IAutoCoverSpecModel;

    documents: IDocumentModel[];
    manufacturerOptions: IDropdownModel[] = [];
    modelOptions: IDropdownModel[] = [];
    showNotes: boolean = false;

    // Desktop only: collapse state of the Auto Cover spec sheet (see equipment-tracking.component)
    showAutoCover: boolean = false;
}

export interface IEquipmentTrackingModel {
    equipmentTrackingId: number;
    companyId: number;
    jobId: number;
    // The pool/spa this equipment is installed on. Null on rows that predate the Assets tab.
    structureId?: number;
    equipmentName: string;
    manufacturer: string;
    otherManufacturer: string;
    model: string;
    oemsku: string;
    serialNumber: string;
    installedDate?: Date;
    documentKey: string;
    isDefault: boolean;
    showDropdown: boolean;
    lockedSerailNumber: boolean;
    lockedInstalledDate: boolean;
    btu: number;
    filterType: string;
    heaterType: string;

    notes: string;
    autoCover: IAutoCoverSpecModel;

    documents: IDocumentModel[];
    manufacturerOptions: IDropdownModel[];
    modelOptions: IDropdownModel[];
    showNotes: boolean;
    showAutoCover: boolean;

}